import {
  ParseRequestResponse,
  ParseRequestUpdateRequest,
} from '../../../../core/clients/omni-core/models';

export interface ParseRequestCreateGeneralFormModel {
  businessRelation: Exclude<ParseRequestUpdateRequest['businessRelation'], undefined> | null;
  businessPartnerName: string;

  satisfied: 'YES' | 'NO' | null;
  unsatisfiedReason: Exclude<ParseRequestUpdateRequest['unsatisfiedReason'], undefined> | null;
  unsatisfiedOtherReason: string;
}

export const toModel = (
  data: Partial<ParseRequestResponse>,
): ParseRequestCreateGeneralFormModel => ({
  businessRelation: data.businessRelation ?? null,
  businessPartnerName: data.businessPartnerName ?? '',
  satisfied: data.unsatisfied === undefined ? null : data.unsatisfied ? 'NO' : 'YES',
  unsatisfiedReason: data.unsatisfiedReason ?? null,
  unsatisfiedOtherReason: data.unsatisfiedOtherReason ?? '',
});

export const toPayload = (
  model: ParseRequestCreateGeneralFormModel,
): ParseRequestUpdateRequest => ({
  businessRelation: model.businessRelation ?? undefined,
  businessPartnerName: model.businessPartnerName || undefined,
  unsatisfied: model.satisfied === null ? undefined : model.satisfied === 'NO',
  unsatisfiedReason: model.unsatisfiedReason ?? undefined,
  unsatisfiedOtherReason: model.unsatisfiedOtherReason || undefined,
});
